import type { PublicTranslations } from './public-ar';

export const publicHe: PublicTranslations = {
  fulfillment: {
    deliveryOnly: 'פעולה זו זמינה להזמנות משלוח בלבד.',
    pickupOnly: 'פעולה זו זמינה להזמנות איסוף עצמי בלבד.',
    busy: 'נתוני ההזמנה מתעדכנים. נסו שוב ובדקו את הפרטים.',
    amountOutOfRange: 'הסכום מחוץ לטווח הנתמך',
    clientUpdateRequired: 'יש לרענן את הדף כדי להמשיך באישור ההזמנה.',
    pickupStockNotice: 'המלאי מופחת בעת אישור ההזמנה.',
    pickupNext: 'יש לאסוף מהמקום המוצג. פנו לחנות לפרטים.',
    collected: 'נאסף',
    legacySubtotal: 'סכום הפריטים — דמי המשלוח לא נשמרו',
    quoteFailed: 'לא ניתן לחשב את הסכום. נסו שוב.',
    quoteLoading: 'מחשבים את הסכום',
    loadFailed: 'לא ניתן לטעון את האפשרויות. נסו שוב.',
    optionsChanged: 'האפשרויות השתנו. יש לבדוק את הפרטים והסכום ולאשר מחדש.',
    unavailable: 'משלוח ואיסוף אינם זמינים כרגע',
    chooseMethod: 'יש לבחור משלוח או איסוף עצמי',
    pickupPlace: 'מקום האיסוף',
    freePickup: 'איסוף עצמי ללא עלות',
    freeDelivery: 'משלוח חינם',
    deliveryFee: 'דמי משלוח',
    pickup: 'איסוף עצמי',
    delivery: 'משלוח',
    title: 'אופן קבלת ההזמנה',
  },
  common: {
    save: 'שמור',
    cancel: 'ביטול',
    delete: 'מחק',
    loading: 'טוען...',
    error: 'אירעה שגיאה',
    retry: 'נסה שוב',
    search: 'חיפוש',
    call: 'שיחה',
    actions: {
      close: 'סגירה',
    },
    phoneCountry: {
      IL: 'ישראל',
      PS: 'פלסטין',
      JO: 'ירדן',
      SY: 'סוריה',
      LB: 'לבנון',
      EG: 'מצרים',
      TR: 'טורקיה',
      US: 'ארצות הברית',
      international: 'מספר בינלאומי',
    },
    languageNames: {
      ar: 'ערבית',
      he: 'עברית',
      en: 'אנגלית',
    },
    errors: {
      permissionDenied: 'אין לך הרשאה לפעולה זו.',
      networkFailed: 'החיבור נכשל. בדוק את הרשת ונסה שוב.',
      storeNotFound: 'החנות הזו אינה קיימת עוד. רענן את הדף.',
      unknown: 'משהו השתבש. נסה שוב.',
    },
  },
  auth: {
    phoneOtp: {
      phoneLabel: 'מספר טלפון',
      phoneHint: 'הכנס מספר עם קידומת מדינה או בחר מדינה.',
      codeLabel: 'קוד אימות',
      codeHint: 'הכנס קוד בן 6 ספרות.',
      requestCode: 'שלח קוד',
      requestingCode: 'שולח...',
      verifyCode: 'אמת קוד',
      verifyingCode: 'מאמת...',
      retryHandoff: 'נסה שוב',
      resendCode: 'שלח קוד חדש',
      changePhone: 'שנה טלפון',
      sentMessage: 'שלחנו קוד אימות לטלפון שלך.',
      smsOnly: 'נשלח את הקוד ב-SMS.',
      existingEmailFallback: 'אין לך טלפון מאומת?',
      useEmailFallback: 'השתמש באימייל וסיסמה',
      usePhoneOtp: 'השתמש בקוד טלפון',
      errors: {
        phoneRequired: 'מספר טלפון נדרש',
        phoneInvalid: 'מספר הטלפון לא תקין',
        codeRequired: 'קוד אימות נדרש',
        codeInvalid: 'הכנס קוד בן 6 ספרות',
        invalidCode: 'הקוד שגוי או פג תוקף',
        customerAccountMissing: 'לא קיים חשבון לקוח לטלפון הזה. צור חשבון קודם.',
        rateLimited: 'יותר מדי ניסיונות. נסה שוב בעוד רגע.',
        networkFailed: 'החיבור נכשל. בדוק את הרשת.',
        cartHandoffFailed: 'התחברת, אך לא הצלחנו להעביר את העגלה. נסה שוב.',
        profileEnsureFailed: 'המספר אומת, אבל לא הצלחנו להכין את חשבון הלקוח. נסו שוב.',
        unknown: 'משהו השתבש. נסה שוב.',
      },
    },
  },
  catalog: {
    products: 'מוצרים',
    outOfStock: 'אזל מהמלאי',
  },
  checkout: {
    cart: 'עגלה',
    total: 'סך הכל',
  },
  customer: {
    phoneCountryLabel: 'קידומת מדינה',
    phoneCountry: {
      IL: 'ישראל',
      PS: 'פלסטין',
      JO: 'ירדן',
      SY: 'סוריה',
      LB: 'לבנון',
      EG: 'מצרים',
      TR: 'טורקיה',
      US: 'ארצות הברית',
    },
    signup: {
      title: 'המשך עם טלפון',
      subtitle: 'קוד אימות אחד מאפשר להמשיך בקנייה.',
      fullNameLabel: 'שם מלא',
      fullNameHint: 'כפי שתרצה שהמוכר יראה אותך',
      emailLabel: 'אימייל',
      emailHint: 'כתובת זו תשמש להתחברות',
      passwordLabel: 'סיסמה',
      passwordHint: '8 תווים לפחות',
      passwordConfirmLabel: 'אימות סיסמה',
      phoneLabel: 'מספר טלפון (לא חובה)',
      phoneHint: 'עוזר למוכר ליצור איתך קשר לגבי ההזמנה',
      phoneCountryLabel: 'קידומת מדינה',
      phoneCountry: {
        IL: 'ישראל',
        PS: 'פלסטין',
        JO: 'ירדן',
        SY: 'סוריה',
        LB: 'לבנון',
        EG: 'מצרים',
        TR: 'טורקיה',
        US: 'ארצות הברית',
      },
      showPassword: 'הצג סיסמה',
      hidePassword: 'הסתר סיסמה',
      submit: 'צור חשבון',
      submitting: 'יוצר חשבון...',
      haveAccount: 'כבר יש לך חשבון?',
      signInLink: 'התחבר',
      successToast: 'החשבון נוצר בהצלחה!',
      errors: {
        fullNameRequired: 'נדרש שם מלא',
        fullNameTooShort: 'השם קצר מדי',
        fullNameTooLong: 'השם ארוך מדי',
        emailRequired: 'אימייל נדרש',
        emailInvalid: 'כתובת אימייל לא תקינה',
        passwordTooShort: 'הסיסמה חייבת להיות לפחות 8 תווים',
        passwordConfirmRequired: 'נדרש אימות סיסמה',
        passwordMismatch: 'הסיסמאות אינן תואמות',
        phoneInvalid: 'מספר הטלפון לא תקף עבור המדינה שנבחרה',
        emailAlreadyExists:
          'כתובת האימייל הזו כבר רשומה. אם את/ה בעל/ת חנות, אפשר להתחבר עם אותו חשבון כדי לקנות.',
        rateLimited: 'יותר מדי ניסיונות. נסה שוב בעוד דקה.',
        networkFailed: 'החיבור נכשל. בדוק את הרשת.',
        accountCreatedSignInFailed: 'החשבון נוצר. נסה להתחבר בעוד רגע.',
        unknown: 'אירעה שגיאה. נסה שוב.',
      },
    },
    header: {
      signUpLink: 'המשך עם טלפון',
      signInLink: 'התחברות',
      avatarMenuLabel: 'תפריט חשבון',
      signOut: 'יציאה',
      myProfile: 'הפרופיל שלי',
      myAddresses: 'הכתובות שלי',
      myOrders: 'ההזמנות שלי',
    },
    login: {
      title: 'המשך עם טלפון',
      subtitle: 'לקוחות חדשים וחוזרים משתמשים באותו קוד טלפון.',
      emailLabel: 'דוא"ל',
      emailHint: 'הכתובת שהזנת ביצירת החשבון',
      passwordLabel: 'סיסמה',
      showPassword: 'הצג סיסמה',
      hidePassword: 'הסתר סיסמה',
      submit: 'התחבר',
      submitting: 'מתחבר…',
      forgotPasswordLink: 'שכחת סיסמה?',
      noAccountYet: 'אין לך חשבון?',
      signUpLink: 'צור חשבון',
      phoneOnlyHint: 'אין צורך באימייל או סיסמה.',
      errors: {
        emailRequired: 'דוא"ל הוא שדה חובה',
        emailInvalid: 'כתובת דוא"ל לא תקינה',
        passwordRequired: 'סיסמה הינה שדה חובה',
        invalidCredentials: 'פרטי התחברות שגויים. נסה שוב.',
        rateLimited: 'יותר מדי ניסיונות. נסה שוב בעוד מספר דקות.',
        networkFailed: 'החיבור נכשל. בדוק את הרשת.',
        unknown: 'משהו השתבש. נסה שוב.',
      },
    },
    passwordReset: {
      request: {
        title: 'איפוס סיסמה',
        subtitle: 'נשלח קישור איפוס לדוא"ל שלך.',
        emailLabel: 'דוא"ל',
        submit: 'שלח קישור איפוס',
        submitting: 'שולח…',
        successTitle: 'בדוק את הדוא"ל שלך',
        successMessage: 'אם יש חשבון עם דוא"ל זה, תקבל הודעה עם קישור איפוס בעוד מספר דקות.',
        backToSignIn: 'חזרה להתחברות',
        errors: {
          emailRequired: 'דוא"ל הוא שדה חובה',
          emailInvalid: 'כתובת דוא"ל לא תקינה',
          rateLimited: 'יותר מדי ניסיונות. נסה שוב בעוד מספר דקות.',
          networkFailed: 'החיבור נכשל. בדוק את הרשת.',
          unknown: 'משהו השתבש. נסה שוב.',
        },
      },
      confirm: {
        title: 'בחר סיסמה חדשה',
        subtitle: 'הכנס סיסמה חדשה כדי להשלים את האיפוס.',
        passwordLabel: 'סיסמה חדשה',
        passwordHint: 'לפחות 8 תווים',
        passwordConfirmLabel: 'אישור סיסמה',
        showPassword: 'הצג סיסמה',
        hidePassword: 'הסתר סיסמה',
        submit: 'שמור סיסמה חדשה',
        submitting: 'שומר…',
        sessionMissingTitle: 'קישור האיפוס פג',
        sessionMissingMessage: 'בקש קישור חדש.',
        sessionMissingCta: 'בקש קישור חדש',
        successToast: 'הסיסמה שונתה. ברוך שובך!',
        errors: {
          passwordTooShort: 'הסיסמה חייבת להכיל לפחות 8 תווים',
          passwordMismatch: 'הסיסמאות אינן תואמות',
          rateLimited: 'יותר מדי ניסיונות. נסה שוב בעוד מספר דקות.',
          networkFailed: 'החיבור נכשל. בדוק את הרשת.',
          unknown: 'משהו השתבש. נסה שוב.',
        },
      },
    },
    profilePlaceholder: {
      title: 'דף החשבון בקרוב',
      subtitle: 'אנחנו עדיין בונים את הדף הזה. חזור בקרוב.',
      cta: 'חזרה לחנות',
      ariaLabel: 'דף חשבון זמני',
    },
    account: {
      pageTitle: 'חשבון',
      ariaLabel: 'דף חשבון',
      subtitle: 'נהל את הפרופיל, הכתובות השמורות וההזמנות שלך.',
      navLabel: 'אזורי החשבון',
      items: {
        profile: {
          title: 'פרופיל',
          description: 'עדכן את השם והשפה המועדפת.',
        },
        addresses: {
          title: 'כתובות שמורות',
          description: 'הוסף, ערוך או בחר כתובת ברירת מחדל למשלוח.',
        },
        orders: {
          title: 'הזמנות',
          description: 'צפה בהזמנות האחרונות ובסטטוס שלהן.',
        },
      },
    },
    profile: {
      pageTitle: 'פרופיל',
      ariaLabel: 'דף הפרופיל',
      editButton: 'ערוך פרופיל',
      addressesButton: 'ניהול כתובות שמורות',
      saveButton: 'שמור שינויים',
      saving: 'שומר…',
      cancelButton: 'ביטול',
      nameLabel: 'שם',
      emailLabel: 'אימייל',
      emailReadOnly: 'לא ניתן לשנות את האימייל כרגע',
      phoneLabel: 'טלפון',
      phoneOptional: 'אופציונלי',
      phoneReadOnly: 'הטלפון מחובר לכניסה ולא ניתן לשנות אותו כאן.',
      phonePlaceholder: '+972501234567',
      localeLabel: 'שפה מועדפת',
      localeAr: 'ערבית',
      localeHe: 'עברית',
      localeEn: 'English',
      successToast: 'השינויים נשמרו בהצלחה',
      signOut: 'התנתקות',
      signingOut: 'מתנתק…',
      deleteAccount: {
        title: 'מחיקת חשבון',
        warning:
          'פעולה זו אינה הפיכה. החשבון שלך יימחק לצמיתות. הזמנות פעילות יישארו גלויות למוכר עם מידע אנונימי.',
        confirmPrompt: 'הקלד "{{word}}" לאישור',
        confirmWord: 'מחק',
        confirmButton: 'מחק חשבון לצמיתות',
        deleting: 'מוחק חשבון…',
      },
      errors: {
        nameRequired: 'שם נדרש',
        nameTooLong: 'השם ארוך מדי (מקסימום 100 תווים)',
        phoneInvalid: 'מספר טלפון לא תקין',
        networkFailed: 'שגיאת חיבור. בדוק את הרשת.',
        rateLimited: 'ניסיונות רבים מדי. נסה שוב בעוד כמה דקות.',
        unknown: 'אירעה שגיאה. נסה שוב.',
        deleteFailed: 'מחיקת החשבון נכשלה. נסה שוב.',
      },
    },
    addresses: {
      pageTitle: 'הכתובות שלי',
      ariaLabel: 'דף הכתובות',
      addNewCta: 'הוספת כתובת חדשה',
      limitReached: 'הגעת למגבלה (20 כתובות). מחק כתובת ישנה כדי להוסיף חדשה.',
      defaultBadge: 'ברירת מחדל',
      makeDefault: 'הפוך לברירת מחדל',
      edit: 'עריכה',
      delete: 'מחיקה',
      actionsMenuLabel: 'פעולות על הכתובת',
      empty: {
        title: 'אין עדיין כתובות שמורות',
        body: 'הוסף כתובת כדי להאיץ את התשלום.',
        cta: 'הוסף את הכתובת הראשונה שלך',
      },
      form: {
        addTitle: 'הוספת כתובת חדשה',
        editTitle: 'עריכת כתובת',
        labelLabel: 'תווית',
        labelPlaceholder: 'לדוגמה: בית, עבודה',
        labelOptional: 'אופציונלי',
        recipientNameLabel: 'שם הנמען',
        addressLine1Label: 'כתובת',
        addressLine2Label: 'שורת כתובת שנייה',
        cityLabel: 'עיר',
        localitySearchPlaceholder: 'חיפוש עיר או יישוב',
        localitySearchPrompt: 'התחל להקליד כדי למצוא עיר או יישוב.',
        localityNoResults: 'לא נמצאה עיר או יישוב מתאים',
        regionLabel: 'מחוז',
        regionFallbackLabel: 'מדינה / מחוז',
        postalCodeLabel: 'מיקוד',
        countryLabel: 'מדינה',
        phoneLabel: 'מספר טלפון',
        phoneOptional: 'אופציונלי — המוכר עשוי להשתמש בזה לתיאום המשלוח.',
        isDefaultLabel: 'הפוך לכתובת ברירת המחדל שלי',
        saveNew: 'שמירת כתובת',
        saveEdit: 'שמירת שינויים',
        cancel: 'ביטול',
        saving: 'שומר…',
      },
      districtIL: {
        northern: 'מחוז הצפון',
        haifa: 'מחוז חיפה',
        central: 'המחוז המרכזי',
        tel_aviv: 'מחוז תל אביב',
        jerusalem: 'מחוז ירושלים',
        southern: 'מחוז הדרום',
      },
      successToast: {
        created: 'הכתובת נשמרה',
        updated: 'הכתובת עודכנה',
        deleted: 'הכתובת נמחקה',
        defaultSet: 'כתובת ברירת המחדל עודכנה',
      },
      deleteConfirm: {
        title: 'למחוק את הכתובת הזו?',
        body: 'הכתובת לא תופיע יותר באפשרויות התשלום. הזמנות קודמות לא יושפעו.',
        confirm: 'מחק',
        deleting: 'מוחק…',
      },
      errors: {
        labelTooLong: 'התווית ארוכה מדי',
        recipientNameRequired: 'שם הנמען נדרש',
        recipientNameTooLong: 'שם הנמען ארוך מדי',
        addressLine1Required: 'כתובת נדרשת',
        addressLine1TooLong: 'הכתובת ארוכה מדי',
        addressLine2TooLong: 'שורת הכתובת השנייה ארוכה מדי',
        cityRequired: 'עיר נדרשת',
        cityTooLong: 'שם העיר ארוך מדי',
        regionRequired: 'מחוז נדרש',
        regionTooLong: 'המחוז ארוך מדי',
        postalCodeRequired: 'מיקוד נדרש',
        postalCodeInvalidIL: 'המיקוד הישראלי חייב להיות 5 או 7 ספרות',
        postalCodeInvalid: 'מיקוד לא תקין',
        countryRequired: 'מדינה נדרשת',
        phoneInvalid: 'מספר טלפון לא תקין',
        networkFailed: 'החיבור נכשל. בדוק את הרשת.',
        rateLimited: 'ניסיונות רבים מדי. נסה שוב בעוד מספר דקות.',
        notFound: 'הכתובת לא נמצאה.',
        deleteFailed: 'לא ניתן למחוק את הכתובת.',
        setDefaultFailed: 'לא ניתן להגדיר את ברירת המחדל.',
        unknown: 'משהו השתבש. נסה שוב.',
      },
    },
    // DEPRECATED: F-019 replaced the orders placeholder with the real order
    // history page. These keys are retained for translator reference only.
    // No runtime code references them. Safe to remove in a future cleanup.
    ordersPlaceholder: {
      title: 'הזמנות בקרוב',
      subtitle: 'אנחנו עדיין בונים את הדף הזה. חזור בקרוב.',
      cta: 'חזרה לחנות',
      ariaLabel: 'דף הזמנות זמני',
    },
    callback: {
      title: 'מאמת...',
      loading: 'רגע בבקשה, אנו מאמתים את האימייל שלך.',
    },
    authGate: {
      title: 'אמת את הטלפון כדי ליצור קשר עם המוכר',
      subtitle: 'כדי לפנות אל {{storeName}} בנוגע ל-{{productName}}, המשך באימות טלפון.',
      signInCta: 'המשך עם טלפון',
      signUpCta: 'המשך עם טלפון',
      closeLabel: 'סגור',
      primedBanner: {
        message: 'התחברת — לחץ על "צור קשר עם המוכר" כדי לשלוח הודעה ל-{{storeName}}',
        dismissLabel: 'סגור',
      },
    },
  },
  cart: {
    errors: {
      insufficientStock: 'מישהו אחר תפס את היחידות האחרונות — נשארו רק {{available}}',
      productNotFound: 'המוצר לא נמצא',
      notAuthenticated: 'יש להתחבר כדי להמשיך',
      permissionDenied: 'אין לך הרשאה לבצע שינוי זה',
      networkFailed: 'החיבור לרשת נכשל. נסה שוב.',
      unknown: 'אירעה שגיאה בלתי צפויה. נסה שוב.',
      storeUnpublished: 'חנות זו אינה מקבלת הזמנות כרגע',
      cartItemNotFound: 'פריט זה כבר לא בעגלה שלך. אנו מרעננים את התצוגה.',
      invalidQuantity: 'לא הצלחנו לעדכן את הכמות. נסה שוב.',
      variantUnavailable: 'האפשרות הזו כבר לא זמינה',
      insufficientVariantStock: 'אין מספיק מלאי לאפשרות זו',
    },
  },
  reviews: {
    verifiedCustomer: 'לקוח מאומת',
    verifiedPurchase: 'רכישה מאומתת',
    merchantResponse: 'תגובת החנות',
    ratingLabel: '{{rating}} מתוך 5',
    reviewCount: '{{count}} ביקורות',
    noReviewsYet: 'אין עדיין ביקורות',
    errors: {
      notEligible: 'המוצר הזה אינו זכאי לביקורת',
      alreadyReviewed: 'כבר נכתבה ביקורת למוצר הזה',
      permissionDenied: 'אין לך הרשאה לשלוח את הביקורת הזו',
      productUnavailable: 'אי אפשר לכתוב ביקורת על המוצר הזה כרגע',
      ratingInvalid: 'בחרו דירוג מ-1 עד 5',
      textTooLong: 'הטקסט חייב להיות עד 1000 תווים',
      whitespaceOnly: 'כתבו טקסט ברור או השאירו את השדה ריק',
    },
  },
  storefront: {
    beauty: {
      shopAll: 'כל המוצרים',
      menu: 'פתיחת תפריט החנות',
      closeMenu: 'סגירת תפריט החנות',
      search: 'חיפוש בחנות',
      searchPlaceholder: 'חיפוש מוצרים',
      closeSearch: 'סגירת החיפוש',
      account: 'החשבון שלי',
      cart: 'סל הקניות',
      productCount: '{{count}} מוצרים',
      loadedCount: 'מוצגים {{loaded}} מתוך {{total}}',
      loadMore: 'הצגת עוד',
      sort: 'מיון מוצרים',
      clearSearch: 'ניקוי החיפוש',
      noResults: 'לא נמצאו מוצרים התואמים לחיפוש.',
      selectShade: 'בחירת גוון',
      selectOptions: 'בחירת אפשרויות',
      shadeCount: '{{count}} גוונים',
      shadeCount_one: 'גוון אחד',
      moreDetails: 'פרטים נוספים',
      details: 'פרטי המוצר',
      shippingReturns: 'משלוחים והחזרות',
      relatedHeading: 'עוד מהקטגוריה הזו',
      reviews: 'ביקורות',
      ratingSummary: 'דירוג {{average}} מתוך 5 לפי {{count}} ביקורות',
      previous: 'הקודם',
      next: 'הבא',
      community: 'הקהילה שלנו',
      browseProduct: 'הצגת {{name}}',
      shop: 'קנייה',
      contact: 'יצירת קשר',
      policies: 'מדיניות החנות',
      currency: 'המחירים בשקלים חדשים',
      newsletterInert: 'תצוגה מקדימה בלבד; אי אפשר לשלוח הרשמה כאן.',
      catalogLoadError: 'לא ניתן לטעון מוצרים. נסו שוב.',
      factsLoadError: 'לא ניתן לטעון את פרטי המוצרים הנוספים.',
      chooseOptions: 'בחרו את כל האפשרויות לפני ההוספה לסל.',
      backToShop: 'חזרה לחנות',
      newsletterHeading: 'נשארים מעודכנים',
      newsletterBody: 'הירשמו לקבלת עדכונים מהחנות.',
      galleryIndex: 'תמונה {{index}} מתוך {{total}}',
      searchSubmit: 'חיפוש',
      footerGroupToggle: 'פתיחה או סגירה של {{group}}',
      communityProductUnavailable: 'המוצר אינו זמין',
    },
    website: {
      luxury: {
        categories: 'גלו את הקטגוריות',
        discoverCategory: 'לגלות את הקולקציה',
        bestSellers: 'הנמכרים ביותר',
        sale: 'מבצעים',
        newArrivals: 'חדש בחנות',
        moreFromCategory: 'עוד מהקטגוריה',
        backToCategory: 'חזרה לקטגוריה',
        productDetails: 'פרטי המוצר',
        merchandisingError: 'לא ניתן לטעון את המוצרים. נסו שוב.',
      },
      fashion: {
        demoWhiteShirt: 'חולצה לבנה מכופתרת',
        demoBlackBag: 'תיק כתף שחור',
        demoCollection: 'פריטי הבסיס',
        viewCollection: 'צפייה בקולקציית {{category}}',
        campaignLoadError: 'לא הצלחנו לטעון את הקולקציה.',
        collectionUnavailableTitle: 'הקולקציה אינה זמינה כרגע',
        collectionUnavailableDescription: 'חזרו לחנות כדי לעיין במוצרים הזמינים.',
        retry: 'נסו שוב',
        previousProductImage: 'התמונה הקודמת של {{name}}',
        nextProductImage: 'התמונה הבאה של {{name}}',
        productImagePosition: 'תמונה {{index}} מתוך {{count}} של {{name}}',
        sizeGuideOpen: 'צפייה במדריך מידות',
        sizeGuideClose: 'סגירת מדריך המידות',
        newsletterCompany: 'חברה',
        sizeGuideTitle: 'מדריך מידות',
        description: 'תיאור',
        detailsCare: 'פרטים וטיפול',
        deliveryReturns: 'משלוחים והחזרות',
        generatedArtwork: 'איורי אופנה סינתטיים מקוריים שנוצרו לתבניות דוקאנטי.',
      },
      credits: {
        licenseScope: 'התמונות המקוריות והעיבודים שלנו כפופים לרישיונות המקושרים להלן.',
        title: 'קרדיטים לתמונות התבניות',
        intro:
          'התמונות המשמשות בתבניות האתרים של דוקאנטי ובתצוגות המקדימות שלהן. בעלי חנויות יכולים להחליף אותן בתמונות משלהם.',
        source: 'התמונה המקורית',
        license: 'רישיון',
        changes:
          'שינויים: חיתוך, שינוי גודל ודחיסה לפורמט WebP; התמונות משמשות גם בצילומי תצוגה מקדימה של התבניות.',
      },
      updating: {
        reload: 'טעינת החנות מחדש',
        reloadFailed: 'החנות עדיין זקוקה לגרסה חדשה יותר. נסו מאוחר יותר.',
        title: 'החנות מתעדכנת',
        body: 'אנא חזרו בעוד מעט.',
        browse: 'גלישה בדוכנתי',
      },
      skipToContent: 'דילוג לתוכן',
      nav: {
        label: 'ניווט בחנות',
        home: 'דף הבית',
        shop: 'חנות',
        about: 'אודות',
        cart: 'עגלה',
        account: 'חשבון',
        search: 'חיפוש',
        openMenu: 'פתיחת תפריט',
        closeMenu: 'סגירת תפריט',
      },
      hero: {
        previous: 'השקופית הקודמת',
        next: 'השקופית הבאה',
        slideStatus: 'שקופית {{current}} מתוך {{total}}',
      },
      media: {
        pause: 'השהיה',
        play: 'הפעלה',
      },
      categories: {
        heading: 'קנייה לפי קטגוריה',
      },
      products: {
        newArrivals: 'חדש באתר',
        bestSellers: 'הנמכרים ביותר',
        trending: 'פופולרי עכשיו',
        related: 'אולי תאהבו גם',
        viewAll: 'הצגת הכול',
      },
      about: {
        title: 'אודות החנות',
        delivery: 'משלוחים',
        returns: 'החזרות',
        contact: 'יצירת קשר',
      },
      product: {
        careTitle: 'טיפול',
        sizeGuideTitle: 'מדריך מידות',
      },
      confirmation: {
        title: 'ההזמנה התקבלה',
        continue: 'המשך קנייה',
      },
      footer: {
        powered: 'מופעל על ידי דוכנתי',
      },
      canvas: {
        checkoutDisabled: 'זהו דף התשלום האמיתי שלכם. שליחת הזמנות כבויה בזמן העריכה.',
        sampleProduct: 'מוצר לדוגמה',
        sampleCategory: 'קטגוריה לדוגמה',
        embeddedBlocked: 'לא ניתן להציג את הדף הזה כאן.',
        orderConfirmationNotice: 'אחרי שלקוח מזמין, הוא רואה כאן את אישור ההזמנה.',
        seeOrderConfirmation: 'הצגת דף אישור ההזמנה',
        notInEditor: 'הדף הזה אינו חלק מעורך חזית החנות.',
        backToStore: 'חזרה לדף הבית של החנות',
      },
    },
    storefrontEngine: {
      fallback: {
        sectionUnavailable: 'אי אפשר להציג את המדור כרגע.',
      },
      liveCanvas: {
        empty: {
          title: 'ממתין לבילדר',
          body: 'המסלול הזה מציג תוכן רק אחרי שבילדר הניהול פותח סשן קנבס מהימן.',
        },
        loading: 'ממתין לבילדר',
        ready: 'הקנבס מוכן',
        renderFailed: 'לא ניתן להציג את הקנבס.',
        invalidPayload: 'מטען הקנבס אינו תקין.',
        invalidRenderData: 'נתוני תצוגת הקנבס אינם תקינים.',
        parityOverlayDisabled: 'שכבת העריכה מוסתרת להשוואה.',
        unavailable: 'הקנבס החי אינו זמין.',
        controlsDisabled: 'פקדי הקנבס אינם זמינים כרגע.',
        selectionLabel: 'בחר מדור בחנות',
        sections: {
          hero: 'מדור הירו',
          header: 'כותרת החנות',
          footer: 'תחתית החנות',
          mobileNav: 'ניווט במובייל',
          benefits: 'יתרונות',
          faq: 'שאלות נפוצות',
          aboutStore: 'על החנות',
          testimonials: 'המלצות',
          newsletterCta: 'קריאה לניוזלטר',
          trustBadge: 'תג אמון',
          promotionalAds: 'מודעות החנות',
          categories: 'קטגוריות',
          liveOffers: 'מבצעים חיים',
          products: 'מוצרים',
          trustSummary: 'סיכום אמון',
        },
        selection: {
          chromeLabel: 'מסומן',
          aria: {
            section: 'מקטע ניתן לבחירה: {{section}}',
            selectedSection: 'המקטע המסומן בקנבס: {{section}}',
          },
        },
        edit: {
          shortLabel: 'עריכה',
          editSection: 'עריכת {{section}}',
          lockedShortLabel: 'נעול',
          lockedSection: '{{section}} מוגן בקנבס הבילדר',
        },
        textFields: {
          editTextField: 'עריכת {{field}} בתוך {{section}}',
          labels: {
            heroHeadline: 'כותרת הירו',
            heroEyebrow: 'פתיח הירו',
            heroDescription: 'תיאור הירו',
            heroPrimaryActionLabel: 'פעולה ראשית בהירו',
            contentHeading: 'כותרת מדור',
            contentBody: 'גוף המדור',
            contentBenefitTitle: 'כותרת יתרון',
            contentBenefitBody: 'גוף יתרון',
            contentFaqQuestion: 'שאלת FAQ',
            contentFaqAnswer: 'תשובת FAQ',
            contentAboutParagraph: 'פסקת על החנות',
            contentTestimonialQuote: 'ציטוט המלצה',
            contentTestimonialName: 'שם ממליץ',
            contentTestimonialContext: 'פרטי המלצה',
            contentNewsletterButton: 'כפתור ניוזלטר',
          },
        },
        richContentFields: {
          editRichContentField: 'עריכת תוכן עשיר עבור {{field}} בתוך {{section}}',
          labels: {
            contentBenefitsBody: 'גוף יתרונות',
            contentBenefitBody: 'גוף יתרון',
            contentFaqBody: 'פתיח שאלות נפוצות',
            contentFaqAnswer: 'תשובה נפוצה',
            contentAboutParagraph: 'פסקת על החנות',
            contentTestimonialsBody: 'פתיח ציטוטים',
            contentTestimonialQuote: 'ציטוט המלצה',
            contentNewsletterBody: 'טקסט קריאת ניוזלטר',
          },
        },
        mediaFields: {
          replaceMediaField: 'החלפת {{field}} בתוך {{section}}',
          labels: {
            heroDesktop: 'תמונת הירו לדסקטופ',
            heroMobile: 'תמונת הירו למובייל',
            trustBadgeImage: 'תמונת תג אמון',
          },
        },
        add: {
          shortLabel: 'הוסף',
          addAfterSection: 'הוסף מדור אחרי {{section}}',
        },
        lifecycle: {
          duplicate: 'שכפול {{section}}',
          hide: 'הסתרת {{section}}',
          show: 'הצגת {{section}}',
          delete: 'מחיקת {{section}}',
          hiddenPlaceholder: '{{section}} מוסתר בטיוטה.',
        },
        visibility: {
          deviceHiddenPlaceholder: '{{section}} מוסתר בגודל התצוגה הזה.',
        },
        heroSchedule: {
          always: 'פעיל תמיד',
          active: 'מוצג עכשיו',
          upcoming: 'מתוזמן',
          expired: 'פג תוקף',
        },
        reorder: {
          handle: 'גרור כדי לסדר מחדש את {{section}}',
          moveUp: 'העבר את {{section}} לפני המדור הקודם',
          moveDown: 'העבר את {{section}} אחרי המדור הבא',
          dropBefore: 'שחרור לפני {{section}}',
          dropAfter: 'שחרור אחרי {{section}}',
          movedBefore: '{{section}} הועבר לפני {{target}}.',
          movedAfter: '{{section}} הועבר אחרי {{target}}.',
        },
        inertAction: 'פעולות קונים מושבתות בקנבס הבילדר.',
        aria: {
          route: 'קנבס בונה החנות',
          selectedSection: 'מדור נבחר בקנבס',
          selectedControls: 'פקדי קנבס למדור {{section}}',
        },
      },
    },
    preview: {
      banner: 'מצב תצוגה מקדימה',
      expired: 'פג התוקף של קישור התצוגה המקדימה.',
      notAvailable: 'התצוגה המקדימה אינה זמינה.',
      noindexLabel: 'מוסתר ממנועי חיפוש',
      unsupportedTitle: 'דף התצוגה המקדימה אינו זמין',
      unsupportedDescription:
        'היעד הזה עדיין אינו חלק מהתצוגה המקדימה הבטוחה. המשך מדף הבית של התצוגה המקדימה.',
      backToPreview: 'חזרה לדף הבית של התצוגה המקדימה',
    },
    welcome: 'ברוכים הבאים ל-Dukanti',
    shopNow: 'קנה עכשיו',
    offerCampaigns: {
      homeRailTitle: 'קמפיינים פעילים',
      liveBadge: 'מבצע פעיל',
      endsIn: 'מסתיים בעוד {{time}}',
      endedTitle: 'המבצע הסתיים',
      endedDescription: 'בדוק את החנות למבצעים נוספים.',
      emptyTitle: 'אין מוצרים זמינים במבצע הזה',
      emptyDescription: 'ייתכן שהמוצרים אזלו או שכבר אינם במבצע.',
      variantLabel: 'אפשרות: {{variant}}',
      homeCta: 'צפייה במבצע',
      shareLabel: 'שיתוף המבצע',
      meta: {
        title: '{{campaignTitle}} מ-{{storeName}}',
        description: 'מבצע פעיל של {{storeName}} לזמן מוגבל.',
      },
    },
    courierManifest: {
      title: 'רשימת משלוחים',
      loading: 'טוען רשימת משלוחים...',
      retry: 'נסה שוב',
      error: {
        title: 'לא ניתן לטעון את רשימת המשלוחים',
        description: 'בדוק את החיבור ונסה שוב. אם הבעיה נמשכת, בקש קישור חדש מהחנות.',
      },
      batchCode: 'קבוצה {{displayCode}}',
      courierGreeting: 'עבור {{name}}',
      expiresAt: 'פג תוקף ב-{{expiresAt}}',
      orders: 'תחנות מסירה',
      orderCount: '{{count}} הזמנות',
      orderLabel: 'תחנה {{displayId}}',
      address: 'כתובת',
      customerPhone: 'טלפון לקוח',
      googleMaps: 'Google Maps',
      waze: 'Waze',
      packageCount: '{{count}} חבילה',
      packageBatchCount: '{{count}} תחנות מסירה',
      notes: 'הערות לקוח',
      openMap: 'פתח מפה',
      storeContact: 'התקשר לחנות: {{phone}}',
      storeContactUnavailable: 'פרטי קשר של החנות אינם זמינים',
      packageTag: 'חבילה {{tag}}',
      proof: {
        submit: 'שליחת אישור מסירה',
        replace: 'החלפת אישור',
        submitted: 'האישור נשלח',
        choosePhoto: 'בחר תמונה',
        chooseFromLibrary: 'בחירה מהספרייה',
        takePhoto: 'צילום תמונה',
        fileSizeKilobytes: '{{count}} קילובייט',
        fileSizeMegabytes: '{{count}} מגה-בייט',
        errors: {
          invalidType: 'יש להשתמש בתמונת JPG, PNG או WebP.',
          tooLarge: 'התמונה חייבת להיות עד 5 MB.',
          notShipped: 'לא ניתן למסור את התחנה הזו מכאן.',
          alreadyConfirmed: 'החנות כבר אישרה את המסירה הזו.',
          uploadFailed: 'לא ניתן להעלות את תמונת האישור. נסה שוב.',
        },
      },
      invalid: {
        title: 'קישור המשלוח אינו זמין',
        body: 'ייתכן שהקישור פג, בוטל או חסר. בקש קישור חדש מהחנות.',
        description: 'ייתכן שהקישור פג, בוטל או חסר. בקש קישור חדש מהחנות.',
      },
    },
    courierPortal: {
      title: 'פורטל שליח',
      invalid: {
        title: 'קישור פורטל השליח אינו זמין',
        description: 'ייתכן שהקישור בוטל או אינו תקין. בקש קישור חדש מהחנות.',
      },
      empty: {
        title: 'אין חבילות מוכנות כרגע',
        description: 'הזמנות שנשלחו ושויכו לשליח הזה יופיעו כאן.',
      },
      localities: {
        title: 'יישובים',
        count: '{{count}} חבילה',
      },
      locality: {
        back: 'חזרה ליישובים',
      },
      language: {
        label: 'שפה',
        ar: 'ערבית',
        he: 'עברית',
        en: 'אנגלית',
      },
      device: {
        forgetAction: 'שכח מכשיר זה',
        title: 'להסיר את המכשיר הזה?',
        description:
          'השתמש בזה אם זה לא הטלפון שלך. המכשיר הזה לא יפתח שוב את הפורטל אלא אם החנות תשלח את הקישור המלא מחדש.',
        confirm: 'הסר מכשיר זה',
      },
      packageCount: '{{count}} חבילה',
      customer: 'לקוח',
      proof: {
        required: 'יש לשלוח הוכחת מסירה לפני סימון החבילה כנמסרה.',
        submitted: 'אישור המסירה נשלח וממתין לאישור החנות.',
        confirmed: 'אישור המסירה אושר על ידי החנות.',
      },
    },
    storeChrome: {
      labels: {
        storeHome: 'בית החנות',
        storeCategories: 'קטגוריות',
        storeSales: 'מבצעים',
        bestSellers: 'הנמכרים ביותר',
        trendingNow: 'פופולרי עכשיו',
        newArrivals: 'חדש בחנות',
        category: 'קטגוריה',
        cart: 'עגלה',
        account: 'חשבון',
        orders: 'הזמנות',
        whatsapp: 'וואטסאפ',
        phone: 'טלפון',
        instagram: 'Instagram',
        facebook: 'Facebook',
      },
      footer: {
        quickLinks: 'קישורי חנות',
        socialLinks: 'רשתות חברתיות',
      },
    },
    home: {
      nav: {
        label: 'ניווט בדף הבית',
        home: 'בית',
        stores: 'חנויות',
        sales: 'מבצעים',
        orders: 'ההזמנות שלי',
        account: 'חשבון',
      },
      storeNav: {
        home: 'חנות',
        sales: 'מבצעים',
      },
      rootLanding: {
        eyebrow: 'Dukanti',
        title: 'קישור החנות המקומית שלך מוכן כשתצטרך אותו',
        subtitle: 'השתמש בקישור החנות שקיבלת, או נהל את הפרופיל וההזמנות שלך מכאן.',
        profile: 'פרופיל',
        openStore: 'פתח חנות',
      },
      hero: {
        badge: 'קנייה מקומית',
        title: 'גלה חנויות מקומיות',
        subtitle: 'עיין בחנויות מהכפר שלך והזמן ישירות מבעלי החנויות.',
        browseStores: 'עיין בחנויות',
        openYourStore: 'פתח חנות',
        fromProduct: 'ממוצר שפורסם',
        fromStore: 'מחנות שפורסמה',
      },
      products: {
        title: 'מוצרים מחנויות מקומיות',
        empty: 'עדיין אין מוצרים שפורסמו.',
        error: 'לא ניתן לטעון מוצרים. נסה שוב.',
        retry: 'נסה שוב',
        viewProductLabel: 'צפה ב-{{productName}}',
      },
      sales: {
        title: 'מבצעים והנחות',
        subtitle: 'מוצרים מוזלים מחנויות מקומיות',
        empty: 'אין מבצעים זמינים כרגע.',
        error: 'לא ניתן לטעון מבצעים. נסה שוב.',
        retry: 'נסה שוב',
      },
      publishedStores: {
        title: 'חנויות מקומיות',
        empty: 'עדיין אין חנויות שפורסמו.',
        error: 'לא ניתן לטעון חנויות. נסה שוב.',
        retry: 'נסה שוב',
      },
      featuredStores: {
        title: 'חנויות מובחרות',
        empty: 'אין עדיין חנויות. היה הראשון לפתוח חנות!',
        error: 'לא ניתן לטעון חנויות. נסה שוב.',
        retry: 'נסה שוב',
        viewStore: 'בקר בחנות',
        viewStoreLabel: 'בקר בחנות — {{storeName}}',
        storeLogoAlt: 'לוגו {{storeName}}',
      },
      howItWorks: {
        title: 'איך זה עובד?',
        step1Title: 'עיין בחנויות',
        step1Description: 'גלה חנויות מקומיות מהכפר שלך ועיין במוצרים שלהם.',
        step2Title: 'צור קשר עם המוכר',
        step2Description: 'צור קשר ישירות עם בעל החנות דרך וואטסאפ או טלפון.',
        step3Title: 'הזמן ואסוף',
        step3Description: 'השלם את ההזמנה ועקוב אחר הפרטים שלה מהחשבון שלך.',
      },
      meta: {
        title: 'Dukanti',
        description: 'פרופיל לקוחות וקישורי חנויות לקוני Dukanti.',
      },
    },
    sale: {
      onSale: 'מבצע',
      discountPercent: '{{percent}}% הנחה',
      originalPrice: 'המחיר המקורי {{price}}',
    },
    contactSeller: {
      prefilledMessage: 'שלום, אני מתעניין ב-{{productName}}. קישור: {{url}}',
      unavailable: 'פרטי התקשרות אינם זמינים',
      modal: {
        title: 'איך תרצה ליצור קשר?',
        whatsapp: 'פתח וואטסאפ',
        phone: 'התקשר',
        close: 'סגור',
      },
    },
    storeNotAvailable: {
      title: 'החנות אינה זמינה',
      description: 'חנות זו אינה זמינה כרגע או שאינה קיימת.',
      backHome: 'חזרה ל-Dukanti',
    },
    storePlaceholder: {
      liveBadge: 'חי',
      comingSoon: 'חוויית החנות המלאה בקרוב',
    },
    storeSales: {
      title: 'מוצרים במבצע',
      subtitle: 'מוצרים מוזלים מהחנות הזו בלבד.',
      emptyTitle: 'אין מבצעים כרגע',
      emptyDescription: 'בדוק את החנות הזו שוב בהמשך למבצעים חדשים.',
      error: 'לא ניתן לטעון מוצרים במבצע. נסה שוב.',
      meta: {
        title: 'המבצעים של {{storeName}}',
        description: 'עיין במוצרים מוזלים מ-{{storeName}}.',
      },
    },
    storeCollections: {
      bestSellers: {
        title: 'הנמכרים ביותר',
      },
      trendingNow: {
        title: 'פופולרי עכשיו',
      },
      newArrivals: {
        title: 'חדש בחנות',
      },
      subtitle: 'מוצרים נבחרים מ-{{storeName}}',
      emptyTitle: 'אין עדיין מוצרים באוסף הזה',
      emptyDescription: 'חזרו לבדוק בהמשך כשהחנות תקבל יותר פעילות.',
      meta: {
        title: '{{collectionName}} של {{storeName}}',
      },
    },
    customProductCollections: {
      subtitle: 'מוצרים נבחרים של {{storeName}}',
      emptyTitle: 'אין מוצרים באוסף הזה כרגע',
      emptyDescription: 'חזרו לבדוק בהמשך כשהחנות תעדכן את האוסף שלה.',
      meta: {
        title: '{{collectionName}} של {{storeName}}',
        description: 'עיינו ב-{{collectionName}} של {{storeName}}.',
      },
    },
    storeCategoriesPage: {
      title: 'כל הקטגוריות',
      subtitle: 'עיינו בכל הקטגוריות הפעילות של {{storeName}}',
      emptyTitle: 'אין קטגוריות עדיין',
      emptyDescription: 'החנות עדיין לא פרסמה קטגוריות עם מוצרים.',
      error: 'לא ניתן לטעון את הקטגוריות. נסו שוב.',
      meta: {
        title: 'הקטגוריות של {{storeName}}',
        description: 'עיינו בכל הקטגוריות של {{storeName}}.',
      },
    },
    storeHeader: {
      homeAriaLabel: 'חזרה אל {{storeName}}',
      storeLogoName: 'חנות {{storeName}}',
      cartAriaLabel: 'עגלה של {{storeName}}',
    },
    // F-005 Phase 4a stub strings — final Hebrew copy lands in Phase 4c.
    storeHome: {
      header: {
        wordmark: 'דוכנתי',
        wordmarkAriaLabel: 'דוכנתי — דף הבית',
      },
      languageSwitcher: 'שפה',
      hero: {
        storeLogoAlt: 'הלוגו של {{storeName}}',
      },
      conversionHero: {
        primaryCta: 'קנה עכשיו',
        categoriesCta: 'עיין בקטגוריות',
        featuredProduct: 'מהחנות',
        visualFallback: 'הצצה מ-{{storeName}}',
        descriptionFallback: 'מוצרים נבחרים של {{storeName}} במקום אחד.',
      },
      contact: {
        title: 'יצירת קשר ישיר עם החנות',
        description: 'בחרו וואטסאפ או שיחה לפי פרטי הקשר שבעל החנות פרסם.',
        whatsapp: 'וואטסאפ',
        phone: 'שיחה',
        whatsappAriaLabel: 'יצירת קשר עם {{storeName}} בוואטסאפ',
        phoneAriaLabel: 'התקשר אל {{storeName}}',
      },
      products: {
        title: 'מוצרים',
      },
      sections: {
        hero: 'חזית החנות',
        contact: 'יצירת קשר ישירה',
        bestSellers: 'הנמכרים ביותר',
        trendingNow: 'פופולרי עכשיו',
        newArrivals: 'חדש בחנות',
        specialOffers: 'מבצעים מיוחדים',
        selectedProducts: 'מוצרים נבחרים',
        customCollection: 'אוסף נבחר',
        sales: 'מבצעים',
        latestProducts: 'המוצרים האחרונים',
        availableNow: 'זמין עכשיו',
        unavailable: 'לא זמין כרגע',
        allProducts: 'כל המוצרים',
        viewAll: 'הצג הכל',
        productsUnavailableHint: 'אלה מוצרים שפורסמו אך אינם זמינים להזמנה כרגע.',
        emptyManualProducts: 'אין מוצרים נבחרים שניתן להציג כרגע.',
        emptyCustomCollection: 'אין מוצרים מהאוסף הזה שניתן להציג כרגע.',
        emptyAutomaticProducts: 'אין מוצרים כשירים שניתן להציג כרגע.',
        railError: 'לא ניתן לטעון את החלק הזה.',
        networkError: 'לא הצלחנו לטעון את המדור. בדקו את החיבור ונסו שוב.',
        unknownError: 'לא הצלחנו לטעון את המדור כרגע.',
      },
      newsletter: {
        contactTypeLabel: 'פרטי קשר',
        email: 'אימייל',
        phone: 'טלפון',
        emailLabel: 'כתובת אימייל',
        phoneLabel: 'מספר טלפון ישראלי',
        emailPlaceholder: 'name@example.com',
        phonePlaceholder: '050 123 4567',
        consentLabel: 'אני מסכים לקבל עדכונים מהחנות הזו דרך פרטי הקשר שאמסור.',
        submit: 'הצטרפות לעדכונים',
        pending: 'שומר...',
        successTitle: 'תודה',
        successBody: 'הבקשה התקבלה.',
        invalidEmail: 'הזינו כתובת אימייל תקינה.',
        invalidPhone: 'הזינו מספר טלפון ישראלי תקין.',
        consentRequired: 'אשרו הסכמה כדי להמשיך.',
        genericError: 'לא ניתן לשמור כרגע. נסו שוב מאוחר יותר.',
      },
      trust: {
        title: 'אמון לקוחות',
        summary: '{{average}} מתוך 5 מתוך {{count}} ביקורות מאומתות',
        badge: '{{average}} · {{count}} ביקורות מאומתות',
      },
      categories: {
        title: 'קנייה לפי קטגוריה',
        viewAll: 'הצגת הכל',
        viewCategory: 'צפייה בקטגוריה {{categoryName}}',
        productCount: '{{count}} מוצרים',
        loadError: 'לא ניתן לטעון את הקטגוריות.',
        imageAlt: 'תמונת קטגוריה {{categoryName}}',
      },
      ads: {
        slideAriaLabel: 'מודעה {{index}} מתוך {{total}}',
        openAd: 'פתיחת המודעה',
        destinationCue: 'לצפייה בפרטים',
        imageAlt: 'מודעה של {{storeName}}',
        previous: 'המודעה הקודמת',
        next: 'המודעה הבאה',
        goToSlide: 'מעבר למודעה {{index}}',
      },
      productImageAlt: 'תמונה של {{productName}}',
      viewProduct: 'צפייה במוצר',
      loadMore: 'הצג עוד',
      loadingMore: 'טוען...',
      productCard: {
        availability: {
          outOfStock: 'אזל מהמלאי',
          onlyNLeft: 'נותרו {{count}} בלבד',
        },
      },
      empty: {
        title: 'אין מוצרים עדיין',
        description: 'החנות הזו עדיין לא הוסיפה מוצרים — חזרו לבדוק מאוחר יותר.',
      },
      errors: {
        loadMoreFailed: 'לא ניתן היה לטעון עוד. נסו שוב.',
        networkFailed: 'החיבור נכשל. בדקו את הרשת שלכם.',
        unknown: 'משהו השתבש. נסו שוב.',
        loadFirstFailed: 'לא ניתן לטעון את המוצרים כעת.',
        loadFirstFailedHint: 'בדקו את החיבור לאינטרנט ונסו שוב.',
      },
      liveRegion: {
        loaded: 'מציג {{count}} מוצרים שנטענו',
        loadedFiltered: 'מוצגים {{visibleCount}} מתוך {{loadedCount}} מוצרים שנטענו',
      },
      loadedFilter: {
        label: 'סינון המוצרים שנטענו',
        placeholder: 'הקלידו שם מוצר מתוך המוצרים שנטענו',
        summary: 'מוצגים {{visibleCount}} מתוך {{loadedCount}} מוצרים שנטענו',
        clear: 'ניקוי הסינון',
        hideUnavailable: 'הסתרת מוצרים שאזלו מתוך המוצרים שנטענו',
        emptyTitle: 'אין מוצרים שנטענו בשם הזה',
        emptyDescription: 'נקו את הסינון או טענו עוד עמוד למוצרים המוצגים.',
      },
      loading: {
        srLabel: 'טוען חנות',
        ariaLabel: 'טוען חנות',
      },
      seo: {
        title: '{{storeName}}',
        fallbackDescription: 'קנייה מ-{{storeName}}',
      },
    },
    productCard: {
      fromPrice: 'החל מ-{{price}}',
      saleFromPrice: 'מבצע החל מ-{{price}}',
    },
    categoryCatalog: {
      backToStore: 'חזרה לחנות',
      productCount: '{{count}} מוצרים',
      search: {
        label: 'חיפוש בתוך {{categoryName}}',
        placeholder: 'חפשו מוצר בקטגוריה הזו',
        clear: 'ניקוי החיפוש',
      },
      sort: {
        label: 'מיון מוצרים',
        default: 'ברירת מחדל',
        priceAsc: 'מחיר: מהנמוך לגבוה',
        priceDesc: 'מחיר: מהגבוה לנמוך',
        newest: 'החדשים ביותר',
        nameAsc: 'שם: א-ת',
      },
      loading: 'טוענים את מוצרי הקטגוריה...',
      empty: {
        title: 'אין מוצרים תואמים',
        description: 'נסו חיפוש אחר או נקו את החיפוש כדי לראות את מוצרי הקטגוריה.',
      },
      emptySearch: {
        title: 'אין מוצרים שמתאימים ל-{{search}}',
        description: 'נסו חיפוש אחר או נקו את החיפוש כדי לראות את מוצרי הקטגוריה.',
        clear: 'ניקוי החיפוש',
      },
      errors: {
        loadFailed: 'לא ניתן לטעון את מוצרי הקטגוריה.',
        loadMoreFailed: 'לא ניתן לטעון מוצרים נוספים מהקטגוריה.',
        networkFailed: 'לא ניתן להתחבר. נסו שוב.',
        unknown: 'אירעה שגיאה לא צפויה.',
      },
      liveRegion: {
        loaded: 'מוצגים {{visibleCount}} מתוך {{totalCount}} מוצרים',
      },
      meta: {
        title: '{{categoryName}} — {{storeName}}',
        description: 'קנו מוצרי {{categoryName}} מ-{{storeName}}.',
      },
    },
    productPlaceholder: {
      title: 'דף המוצר בפיתוח',
      description: 'אנחנו עובדים על דפי מוצרים. תוכלו לחזור לחנות ולעיין במוצרים הזמינים.',
      backToStore: 'חזרה לחנות',
    },
    productDetail: {
      backToStore: 'חזרה ל-{{storeName}}',
      categoryLabel: 'קטגוריה',
      descriptionLabel: 'תיאור',
      contactSeller: 'פנייה למוכר',
      outOfStock: 'אזל מהמלאי',
      availability: {
        inStock: 'במלאי',
        lowStock: 'נותרו {{count}} בלבד',
        outOfStock: 'אזל מהמלאי',
      },
      variants: {
        chooseOption: 'בחר {{option}}',
        available: 'זמין',
        disabled: 'לא זמין למכירה',
        unavailable: 'לא זמין',
        outOfStock: 'אזל מהמלאי',
        lowStock: 'נותרו רק {{count}}',
        selectRequired: 'בחר אפשרות לפני הוספה לעגלה',
      },
      quantity: {
        label: 'כמות',
        decreaseAriaLabel: 'הפחת כמות',
        increaseAriaLabel: 'הוסף כמות',
        helperMustBeBetween: 'הזינו מספר שלם בין 1 ל-{{max}}',
        helperExceedsAvailable: 'זמינים רק {{available}}',
        helperOnlyNLeft: 'נותרו {{count}} בלבד',
        outOfStockReplacement: 'אזל מהמלאי',
        maxInCartReplacement: 'הכמות המרבית כבר בסל שלך',
      },
      gallery: {
        previousImage: 'התמונה הקודמת',
        nextImage: 'התמונה הבאה',
        goToImage: 'מעבר לתמונה {{index}}',
        paginationLabel: 'מעבר בין תמונות',
        thumbnailLabel: 'תמונה ממוזערת {{index}}',
        noImages: 'אין תמונות למוצר זה',
        zoomImage: 'הגדלת תמונה {{index}}',
        zoomOverlayLabel: 'תצוגת תמונה בגודל מלא',
        zoomClose: 'סגירה',
        zoomCounter: '{{current}} / {{total}}',
        zoomResetZoom: 'איפוס הגדלה',
      },
      seo: {
        title: '{{productName}} — {{storeName}}',
        fallbackDescription: 'קנייה של {{productName}} מ-{{storeName}}',
      },
      loading: {
        srLabel: 'טוען מוצר',
      },
      share: {
        button: 'שיתוף',
        copyButton: 'העתקת קישור',
        shareAriaLabel: 'שתף את {{productName}}',
        copyAriaLabel: 'העתק קישור אל {{productName}}',
        nativeText: '{{productName}} מ-{{storeName}}',
        toast: {
          sharedTitle: 'המוצר שותף',
          copiedTitle: 'הקישור הועתק',
          failedTitle: 'השיתוף נכשל',
          failedBody: 'לא הצלחנו לשתף או להעתיק את קישור המוצר. נסה שוב.',
        },
      },
      reviews: {
        title: 'ביקורות לקוחות',
        summary: '{{average}} · {{count}} ביקורות',
        retry: 'טעינת ביקורות מחדש',
        yourReviewTitle: 'הביקורת שלך',
        editYourReview: 'עריכת ביקורת',
        editTitle: 'עריכת הביקורת שלך',
        saveEdit: 'שמירת ביקורת',
        editSuccess: 'הביקורת שלך עודכנה',
        hiddenOwnReview:
          'הביקורת הזו מוסתרת מקונים כרגע. השינויים שלך יישארו מחוברים לאותה קנייה מאומתת.',
      },
    },
    cart: {
      addToCart: 'הוסף לסל',
      adding: 'מוסיף…',
      outOfStockButton: 'אזל מהמלאי',
      maxInCartButton: 'הכמות המרבית בסל',
      persistenceError:
        'לא הצלחנו לשמור את הפריט הזה בסל בדפדפן הזה. בדוק את הגדרות האחסון או הגלישה הפרטית ונסה שוב.',
      successToast: {
        title: 'נוסף לסל',
        body: '{{productName}} × {{quantity}}',
        viewCart: 'הצג סל',
      },
      errorToast: {
        title: 'לא ניתן להוסיף לסל',
      },
      line: {
        variantSummary: '{{summary}}',
      },
      primedBanner: {
        title: 'ממשיכים מאיפה שעצרנו — הוסף את {{storeName}} לסל שלך',
        dismiss: 'סגור',
      },
      postAddPanel: {
        title: '{{productName}} נוסף לסל שלך',
        body: 'בסל שלך יש עכשיו {{quantity}}.',
        viewCart: 'הצג סל',
        continueShopping: 'המשך קנייה',
        dismiss: 'סגור',
      },
      // F-015: cart header icon + badge + dropdown.
      // Hebrew CLDR plural rules use _one (1), _two (2), _many (20/30/...),
      // and _other (everything else). _zero and _few are never resolved by
      // CLDR for Hebrew, but we seed them with _other to satisfy the
      // i18n parity test (set-equality with ar.ts / en.ts).
      header: {
        // iconLabel (6 forms)
        iconLabel_zero: 'עגלה ריקה',
        iconLabel_one: 'עגלה — פריט אחד',
        iconLabel_two: 'עגלה — שני פריטים',
        iconLabel_few: 'עגלה — {{count}} פריטים', // seeded = _other
        iconLabel_many: 'עגלה — {{count}} פריטים', // seeded = _other
        iconLabel_other: 'עגלה — {{count}} פריטים',

        // static strings
        dropdownTitle: 'העגלה שלך',
        dropdownAriaLabel: 'תצוגה מקדימה של העגלה',
        subtotal: 'סכום ביניים',
        viewCart: 'הצג עגלה',
        emptyTitle: 'העגלה שלך ריקה',
        browseProducts: 'עיין במוצרים',
        // Security W4: pure translated string — no interpolation.
        loadError: 'טעינת העגלה נכשלה',

        // itemCountSuffix (6 forms)
        itemCountSuffix_zero: 'אין פריטים',
        itemCountSuffix_one: 'פריט אחד',
        itemCountSuffix_two: 'שני פריטים',
        itemCountSuffix_few: '{{count}} פריטים',
        itemCountSuffix_many: '{{count}} פריטים',
        itemCountSuffix_other: '{{count}} פריטים',

        // moreItems (6 forms)
        moreItems_zero: '+אין נוספים',
        moreItems_one: '+פריט נוסף',
        moreItems_two: '+שני פריטים נוספים',
        moreItems_few: '+{{count}} נוספים',
        moreItems_many: '+{{count}} נוספים',
        moreItems_other: '+{{count}} נוספים',

        // itemsUnavailable (6 forms)
        itemsUnavailable_zero: 'אין פריטים לא זמינים',
        itemsUnavailable_one: 'פריט אחד אינו זמין',
        itemsUnavailable_two: 'שני פריטים אינם זמינים',
        itemsUnavailable_few: '{{count}} פריטים אינם זמינים',
        itemsUnavailable_many: '{{count}} פריטים אינם זמינים',
        itemsUnavailable_other: '{{count}} פריטים אינם זמינים',
      },
      // F-016: full cart page strings.
      page: {
        title: 'עגלת הקניות',
        subtitle: 'בדוק את הפריטים לפני המעבר לתשלום',
        breadcrumbBack: 'חזרה לחנות',
        empty: {
          title: 'העגלה שלך ריקה',
          body: 'עוד לא הוספת פריטים לעגלה.',
          browseProducts: 'עיין במוצרים',
        },
        line: {
          removeAriaLabel: 'הסר את {{productName}} מהעגלה',
          unitPrice: '{{price}} ליחידה',
          lineSubtotal: 'סכום ביניים לשורה',
          priceUpdated: 'המחיר השתנה',
          priceWas: 'היה: {{oldPrice}}',
          priceNow: 'עכשיו: {{newPrice}}',
          unavailable: 'לא זמין',
          unknownProduct: 'המוצר אינו זמין עוד',
          imageAlt: 'תמונה של {{productName}}',
        },
        unavailableBanner: {
          title: 'חלק מהפריטים אינם זמינים עוד',
          body: '{{count}} פריטים אינם זמינים יותר לרכישה. הסר אותם כדי להמשיך לאישור ההזמנה.',
        },
        handoffRecovery: {
          retrying: 'מעבירים את העגלה אחרי ההתחברות...',
          partial: 'לא הצלחנו להעביר את כל פריטי העגלה. בדוק את העגלה ואז נסה לאשר את ההזמנה שוב.',
          savedIntentTitle: 'חלק מהפריטים השמורים דורשים בדיקה',
          savedIntentBody:
            'הפריטים האלה עדיין שמורים בדפדפן הזה ולא עברו לעגלת החשבון. הסר מה שאינך רוצה ואז נסה לאשר את ההזמנה שוב.',
          retrySavedItems: 'נסה להעביר שוב את הפריטים השמורים',
        },
        summary: {
          title: 'סיכום ההזמנה',
          subtotal: 'סכום ביניים',
          itemCount_zero: 'אין פריטים',
          itemCount_one: 'פריט אחד',
          itemCount_two: 'שני פריטים',
          itemCount_few: '{{count}} פריטים',
          itemCount_many: '{{count}} פריטים',
          itemCount_other: '{{count}} פריטים',
          stockCheckNote: 'הפריטים נשארים בעגלה בלי לשמור מלאי. הזמינות תאושר בעת שליחת ההזמנה.',
          proceedToCheckout: 'המשך לאישור ההזמנה',
          checkoutDisabledHint: 'הסר פריטים שאינם זמינים כדי להמשיך',
          checkoutDisabledHandoffHint: 'בדוק או הסר פריטי עגלה שמורים לפני ההמשך',
          signinRequiredDialog: {
            title: 'אמת את הטלפון כדי לאשר את ההזמנה',
            body: 'נשלח קוד אחד ואז נחזיר אותך לאישור ההזמנה. העגלה שלך תישאר שמורה כאן.',
            continue: 'המשך עם טלפון',
            cancel: 'הישאר בעגלה',
          },
        },
        removeDialog: {
          title: 'להסיר את {{productName}}?',
          body: '{{productName}} יוסר מהעגלה.',
          confirm: 'הסר',
          cancel: 'ביטול',
        },
        errors: {
          refetchFailed: 'טעינת העגלה נכשלה. נסה שוב.',
          updateFailed: 'עדכון העגלה נכשל',
          removeFailed: 'הסרת הפריט מהעגלה נכשלה',
        },
        toast: {
          removed: '{{productName}} הוסר מהעגלה',
        },
        skeleton: {
          loadingAriaLabel: 'טוען את העגלה',
        },
        retryButton: 'נסה שוב',
      },
    },
    // F-017: real checkout flow.
    checkout: {
      review: {
        cartChanged: 'הפריטים בסל השתנו. בדקו את הסל המעודכן ואשרו מחדש.',
        cartRefreshFailed: 'לא ניתן לרענן את הסל. נסו שוב לפני אישור ההזמנה.',
        verificationFailed: 'לא ניתן לאמת את פריטי הסל. נסו שוב לפני האישור.',
      },
      page: {
        title: 'השלמת הזמנה',
        backToCart: 'חזרה לעגלה',
        shippingSection: 'כתובת למשלוח',
        changeAddress: 'שנה כתובת',
        useDifferentAddress: 'השתמש בכתובת אחרת',
        manageAddresses: 'ניהול כתובות שמורות',
        saveForNextTime: 'שמור כתובת זו לפעם הבאה',
        localityPlaceholder: 'בחר עיר או יישוב',
        localityLoading: 'טוען יישובים...',
        localityError: 'לא ניתן לטעון יישובים. נסה שוב.',
        notesSection: 'הערות למוכר',
        submitCta: 'אישור הזמנה',
        deliveryPriceNoticeTitle: 'מחיר המשלוח יאושר בנפרד',
        deliveryPriceNotice:
          'מחיר המשלוח עדיין לא כלול. החנות תיצור איתך קשר כדי לאשר את עלות המשלוח לפני שליחת ההזמנה.',
      },
      deliveryMethod: {
        title: 'שיטת משלוח',
        location: 'מיקום',
        address: 'כתובת',
      },
      deliveryInfo: {
        title: 'פרטי משלוח',
        description: 'ספרו לחנות לאן לשלוח. מיקום מדויק הוא אופציונלי.',
        localityLabel: 'עיר או יישוב',
        postalCodeLabel: 'מיקוד',
        recipientLabel: 'שם הנמען',
        backupPhoneLabel: 'טלפון חלופי',
        errors: {
          localityRequired: 'בחרו עיר או יישוב.',
          postalCodeRequired: 'הזינו מיקוד.',
          postalCodeInvalid: 'הזינו מיקוד ישראלי תקין.',
          recipientRequired: 'הזינו את שם הנמען.',
          recipientTooLong: 'שם הנמען ארוך מדי.',
          backupPhoneInvalid: 'הזינו מספר טלפון חלופי תקין.',
        },
      },
      deliveryLocation: {
        title: 'מיקום מדויק למשלוח',
        description: 'שתף את המיקום הנוכחי כדי שהסוחר יוכל להגיע לנקודת המשלוח המדויקת.',
        localityLabel: 'עיר או יישוב',
        localityRequired: 'בחר עיר או יישוב לפני שיתוף המיקום.',
        homeWarning: 'השתמש באפשרות הזו רק כשאתה בבית או במקום שבו אתה בדרך כלל מקבל משלוחים.',
        cta: 'שתף את המיקום המדויק שלי',
        update: 'עדכן מיקום מדויק',
        locating: 'מאתר מיקום...',
        shared: 'מיקום מדויק נוסף למשלוח',
        clear: 'הסר מיקום',
        denied: 'הרשאת המיקום נדחתה. אפשר עדיין להשלים את ההזמנה בלי GPS.',
        deniedWithExisting: 'הרשאת המיקום נדחתה. המיקום המדויק שנוסף קודם עדיין מצורף להזמנה הזו.',
        unavailable: 'מיקום מדויק אינו זמין במכשיר הזה. אפשר עדיין להשלים את ההזמנה בלי GPS.',
        unavailableWithExisting:
          'מיקום מדויק אינו זמין במכשיר הזה. המיקום שנוסף קודם עדיין מצורף להזמנה הזו.',
      },
      locationModal: {
        title: 'לשתף מיקום מדויק?',
        body: 'הדפדפן יבקש הרשאה. נוסיף את הקואורדינטות להזמנה הזו בלבד.',
        confirmCta: 'שתף מיקום',
        cancelCta: 'ביטול',
      },
      modal: {
        title: 'אישור הזמנה',
        body: 'אתה עומד לשלוח הזמנה ל{{storeName}}.',
        itemCount_one: 'פריט אחד',
        itemCount_other: '{{count}} פריטים',
        subtotal: 'סכום ביניים',
        confirmCta: 'אישור',
        cancelCta: 'ביטול',
      },
    },
  },
  // F-017: order domain namespace.
  order: {
    submit: 'שלח הזמנה',
    confirm: 'אשר הזמנה',
    cancel: 'בטל הזמנה',
    placed: 'ההזמנה נשלחה',
    tracking: 'מעקב הזמנה',
    shippingAddress: 'כתובת למשלוח',
    deliveryInformation: 'פרטי משלוח',
    preciseLocation: 'מיקום מדויק למשלוח',
    orderSummary: 'סיכום הזמנה',
    stockCheckNotice: 'המלאי נשמר בעת שליחת ההזמנה. המוכר ייצור איתך קשר לתיאום המשלוח.',
    notes: {
      placeholder: 'הוסף הערות למוכר (אופציונלי)',
      maxLengthHint: '{{current}}/{{max}}',
    },
    status: {
      ordered: 'הוזמן',
      shipped: 'נשלח',
      delivered: 'נמסר',
      cancelled: 'בוטל',
      rejected: 'נדחה',
    },
    // F-018: order confirmation page keys
    headline: {
      placed: 'ההזמנה התקבלה!',
      ordered: 'ההזמנה התקבלה!',
      shipped: 'ההזמנה נשלחה!',
      delivered: 'ההזמנה הגיעה!',
      cancelled: 'ההזמנה בוטלה',
      rejected: 'ההזמנה נדחתה',
    },
    whatHappensNext: 'מה קורה עכשיו?',
    whatHappensNextBody:
      'המוכר יבדוק את ההזמנה שלך וייצור איתך קשר דרך WhatsApp או טלפון כדי לאשר משלוח ולסדר תשלום. אפשר לעקוב אחרי סטטוס ההזמנה כאן בכל זמן.',
    contactMerchant: 'יצירת קשר עם המוכר',
    contactMerchantWhatsappMessage:
      'שלום {{storeName}}, אני רוצה לשאול על ההזמנה שלי מספר {{orderId}}',
    contactMerchantWhatsappAriaLabel: 'שליחת הודעת ווטסאפ אל {{storeName}} לגבי הזמנה זו',
    contactMerchantPhoneAriaLabel: 'התקשר אל {{storeName}} לגבי הזמנה זו',
    id: 'מספר הזמנה',
    placedDate: 'תאריך הזמנה',
    cancelButton: 'ביטול הזמנה',
    cancelQuestion: 'שינית את דעתך?',
    cancelConfirmTitle: 'לבטל את ההזמנה?',
    cancelConfirmBody: 'הפעולה תבטל את ההזמנה ותחזיר את הפריטים למלאי החנות.',
    cancelConfirmCta: 'כן, בטל הזמנה',
    cancelSuccess: 'ההזמנה שלך בוטלה',
    timeline: {
      title: 'מעקב הזמנה',
      completedOn: 'הושלם ב-{{- date}}',
    },
    viewAllOrders: 'צפייה בכל ההזמנות',
    backToStore: 'חזרה לחנות',
    customerNotes: 'ההערות שלך למוכר',
    loadingDetails: 'טוען פרטי הזמנה',
    reviewPrompt: {
      title: 'ביקורות להזמנה הזו',
      submit: 'שליחת ביקורת',
      alreadyReviewed: 'כבר נכתבה ביקורת למוצר הזה',
      ratingRequired: 'בחרו דירוג מ-1 עד 5',
      textTooLong: 'הטקסט חייב להיות עד 1000 תווים',
      whitespaceOnly: 'כתבו טקסט ברור או השאירו את השדה ריק',
      success: 'הביקורת נשלחה',
      openDialog: 'כתיבת ביקורת',
      ratingOnlyHint: 'אפשר לשלוח דירוג בלבד או להוסיף טקסט קצר.',
      reviewedHint: 'הביקורות ששלחת נשארות מחוברות למוצרים שנמסרו.',
      yourReview: 'הביקורת שלך',
      editReview: 'עריכת ביקורת',
      hiddenReview: 'מוסתרת מקונים כרגע. העריכה שומרת על קישור הקנייה המאומת.',
      merchantResponse: 'תגובת המוכר',
      textLabel: 'טקסט הביקורת',
      textPlaceholder: 'כתבו מה חשבתם על המוצר',
      dialogTitle: 'ביקורת על {{productName}}',
      close: 'סגירה',
    },
    errors: {
      productUnavailable: 'חלק מהמוצרים אינם זמינים יותר: {{names}}',
      variantUnavailable: 'אחת האפשרויות כבר לא זמינה. בדוק את העגלה.',
      cartEmpty: 'העגלה ריקה. הוסף מוצרים לפני השלמת ההזמנה.',
      storeUnavailable: 'החנות אינה מקבלת הזמנות כרגע.',
      networkFailed: 'שגיאת חיבור. בדוק את הרשת ונסה שוב.',
      unknown: 'אירעה שגיאה. נסה שוב.',
      // F-018: cancel-specific error keys
      cancelFailed: 'לא ניתן לבטל את ההזמנה. נסה שוב.',
      cancelAlreadyProcessed: 'לא ניתן לבטל הזמנה זו במצבה הנוכחי.',
      orderNotFound: 'ההזמנה לא נמצאה.',
    },
    history: {
      title: 'ההזמנות שלי',
      totalOrders: '{{count}} הזמנות',
      activeOrders: '{{count}} פעילות',
      filterLabel: 'סינון לפי סטטוס',
      filterAll: 'הכל',
      itemCount: '{{count}} פריטים',
      viewOrder: 'צפה',
      loadMore: 'טען עוד',
      loadingMore: 'טוען...',
      loadingOrders: 'טוען הזמנות',
      backToAccount: 'חשבון',
      emptyAllCta: 'עיין בחנויות',
      emptyAllSubtitle: 'עיין בחנויות והתחל לקנות',
      emptyFilteredHint: 'נסה סינון אחר או בדוק מאוחר יותר',
      empty: {
        all: 'לא הוגשו הזמנות עדיין',
        ordered: 'אין הזמנות שממתינות למשלוח',
        shipped: 'אין הזמנות שנשלחו',
        delivered: 'אין הזמנות שנמסרו',
        cancelled: 'אין הזמנות מבוטלות',
        rejected: 'אין הזמנות שנדחו',
      },
    },
    // F-020: status-change toast key
    statusChangedToast: 'ההזמנה שלך עכשיו {{status}}',
  },
  errors: {
    notFound: 'הדף לא נמצא',
    networkFailed: 'החיבור לרשת נכשל',
    title: 'אירעה שגיאה לא צפויה',
    description: 'אנו מתנצלים על אי-הנוחות. ניתן לנסות שוב.',
    retry: 'נסה שוב',
  },
};
